import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { dateAdapter } from '@uplift/services';
import { MobileCalendarWeeksProps } from '../shared';
import { MobileCalendarDay } from './MobileCalendarDay.component';


const useStyles = makeStyles()({
  week: {
    display: 'flex',
  }
});


export const MobileCalendarWeeks: React.FC<MobileCalendarWeeksProps> = ({ components, currentMonth, today, date, handleDateSelect, disablePastDays }) => {
  const { classes } = useStyles();
  const weeks = React.useMemo(() => dateAdapter.getWeekArray(currentMonth), [ currentMonth ]);
  const DayComponent = components?.Day ?? MobileCalendarDay;

  return (
    <>
      {weeks.map((week, _index) => (
        <Box key={week[0].format()} className={classes.week}>
          {week.map(day => (
            <DayComponent
              key={day.format()}
              onSelect={handleDateSelect}
              today={today}
              currentMonth={currentMonth}
              selectedDate={date}
              date={day}
              disablePastDays={disablePastDays}
            />
          ))}
        </Box>
      ))}
    </>
  );
};
